/* eslint-disable @typescript-eslint/default-param-last */
import { ICodeEditorType } from "@/types/codeEditor.types";
import {
  CODE_EDITOR_LIBRARY_LOADED,
  GET_TECHNOLOGIES,
} from "@/constants/ActionTypes";
import initialState from "@/store/initialState";

const codeEditorReducer = (
  state = initialState.codeEditor,
  action: ICodeEditorType,
) => {
  switch (action.type) {
    case CODE_EDITOR_LIBRARY_LOADED:
      return {
        ...state,
        isCodeEditorLibraryLoaded: action.payload.isCodeEditorLibraryLoaded,
      };
    case `${GET_TECHNOLOGIES}_SUCCESS`:
      return {
        ...state,
        technologies: action.payload.technologies,
      };
    default:
      return state;
  }
};

export default codeEditorReducer;
